import { render } from "./ViewThankYou.vue?vue&type=template&id=b0c88fdc&scoped=true"
const script = {}

import "./ViewThankYou.vue?vue&type=style&index=0&id=b0c88fdc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c88fdc"]])

export default __exports__